/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './HotTopic.css';

import CustomChart from '../../../components/CustomChart/CustomChart'
import {gutt as guttOption} from '../../../chart'
import { CustomizedForm } from '../components/baseForm'
import baseFiled from '../components/baseFiled';
import HotTopicPane from '../components/HotTopic'
import { isArray } from 'util';

const checkPx = (str) => {
  let _str = str + '';
  if (_str.indexOf('%')) {
    return _str;
  } else {
    return _str + 'px'
  }
}


class HotTopic extends React.Component {
  state = {
    fields: {
      ...Object.assign(baseFiled, {
        titleText: {
          value: 'Apple、华为、三星内容条数对比'
        },
        subTitleText: {
          value: '2019.11.01-2019.11.10'
        }
      })
    },
    axis: 'horizontal',
    list: [],
    dataSource: 'input',
    chartWidth: '100%',
    chartHeight: '100%',
    chart: {},
    interfaceData: {},
    dateInterval: 'day' //day, week, month
  }

  componentDidMount() {
    const d = [{"name":"华为智慧屏搭载鸿蒙OS","begin":"2019/8/1","end":"2019/8/31","date":["2019-08-01","2019-08-02","2019-08-03","2019-08-04","2019-08-05","2019-08-06","2019-08-07","2019-08-08","2019-08-09","2019-08-10","2019-08-11","2019-08-12","2019-08-13","2019-08-14","2019-08-15","2019-08-16","2019-08-17","2019-08-18","2019-08-19","2019-08-20","2019-08-21","2019-08-22","2019-08-23","2019-08-24","2019-08-25","2019-08-26","2019-08-27","2019-08-28","2019-08-29","2019-08-30","2019-08-31"],"list":[{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-01","2019-08-02",0]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-02","2019-08-03",0]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-03","2019-08-04",2]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-04","2019-08-05",3]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-05","2019-08-06",545]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-06","2019-08-07",6]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-07","2019-08-08",6]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-08","2019-08-09",6]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-09","2019-08-10",7]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-10","2019-08-11",7]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-11","2019-08-12",0]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-12","2019-08-13",5]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-13","2019-08-14",5]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-14","2019-08-15",4]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-15","2019-08-16",4]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-16","2019-08-17",3]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-17","2019-08-18",1]},{"name":"华为智慧屏搭载鸿蒙OS","value":[0,"2019-08-18","2019-08-19",3]}]}]
    this.setState({
      list: d,
    }, this.init)
  }

  init = () => {
    const {fields, dateInterval} = this.state;

    const data = JSON.parse(JSON.stringify(this.getOption())) 

    console.log(data);

    if (dateInterval === 'week') {
      const {formatWeek} = require('./format')
      formatWeek(data)
    } else if (dateInterval === 'month') {
      const {formatMonth} = require('./format')
      formatMonth(data)
    } 

    if (data.list && data.list.length > 5500) {
      alert('数据太大，建议更改时间间隔重新渲染')
    }

    // ---------------------------重排topic顺序 - begin ----------------------------
    // const {formatSort} = require('./format')
    // formatSort(data)
    // ---------------------------重排topic顺序 - end   ----------------------------

    // ---------------------------按topic筛选展示 - begin --------------------------
    // const {formatFilterForList} = require('./format')
    // formatFilterForList(data)
    // ---------------------------按topic筛选展示 - end   --------------------------

    // -------------------------- 数据按月算 - begin -------------------------------
    // const {formatMonth} = require('./format')
    // formatMonth(data)
    // -------------------------- 数据按月算 - end   -------------------------------

    // -------------------------- 数据按星期算 - begin -----------------------------
    // const {formatWeek} = require('./format')
    // formatWeek(data)
    // -------------------------- 数据按星期算 - end   -----------------------------


    this.setState({
      chartHeight: checkPx(fields.chartHeight.value),
      chartWidth: checkPx(fields.chartWidth.value),
      chart: {dispose: true, ...guttOption(data)}
    })
  }

  handleFormChange = (props, changedFields) => {
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        ...changedFields
      }
    }));
  }

  handleAdd = (props, changedFields) => {
    if (isArray(changedFields)) {
      this.setState({
        list: changedFields
      })
    } else {
      this.setState({
        ...changedFields
      })
    }
  }

  handleClick = () => {
    this.init()
  }

  getOption = () => {
    const {list, dataSource, interfaceData} = this.state
    if (dataSource !== 'input') return interfaceData

    const result = {
      date: [],
      yAxis: [],
      list: []
    }

    list.forEach((item, index) => {

      if (index === 0) {
        result.date = [...item.date]
      }
      const name = item.name.replace('\\n', '\n').replace('\\s', ' ')
      if (result.yAxis.includes(name)) {
        result.yAxis.push(`${name}[${index}]`)
      } else {
        result.yAxis.push(name)
      }
      result.list.push(...item.list)
    })
    return result
  }

  render() {
    const {fields, list, colorList, chartWidth, chartHeight, chart, dataSource, interfaceData, dateInterval} = this.state;
    return (
      <CustomChart width={chartWidth} height={chartHeight} chart={chart} callback={this.handleClick}>
        <HotTopicPane list={list} dataSource={dataSource} interfaceData={interfaceData} dateInterval={dateInterval} color={colorList} onChange={this.handleAdd} />
        <CustomizedForm {...fields} onChange={this.handleFormChange} />
      </CustomChart>
    )
  }
}

export default withStyles(s)(HotTopic);



// WEBPACK FOOTER //
// src/routes/customChart/HotTopic/index.js